export default {
    // --------Title--------
    fullDetailsOfBusinessProfile: 'Full details of business profile',
    fullAddressDetailsOfBusinessInformation: 'Full address details of business information',
    
    // --------MUI--------
    idNo: 'ID No.',
    idNumber: 'ID Number',
    website: 'Website',

};